<section id="about">
    <div class="grid-container">
        <div>
            <h3 class="title">درباره ما</h3>

            <p class="text-justify" style="line-height: 30px;text-align: justify;">
                سامانه <strong>ردیاب شیلات</strong> با مدیریت سازمان شیلات ایران تحت نظارت اتحادیه سراسری تعاونی‌ های
                صیادی ایران و همکاری شرکت دانش‌ بنیان رایان اندیشه نصر ایجاد شده است تا بستری امن، شفاف و قابل اعتماد
                برای مدیریت و سامان‌ دهی ناوگان صیادی کشور فراهم کند.این سامانه با هدف تأمین دقیق و منظم سوخت مورد نیاز
                صیادان، افزایش امنیت و پایش لحظه‌ای شناورها، اطلاع‌رسانی فوری در شرایط بحرانی و اضطراری و بهبود فرآیند‌
                های نظارتی و خدمات پشتیبانی توسعه یافته است. <strong>ردیاب شیلات</strong> تلاش می‌کند با بهره‌ گیری از
                فناوری‌های نوین، اعتماد، آرامش و اطمینان بیشتری برای صیادان ایجاد کرده و گامی مؤثر در راستای صیادی
                پایدار، مدیریت هوشمند سفرهای دریایی و حفاظت از جان و سرمایه صیادان بردارد.</p>
        </div>
        <div>
            <h3 class="title">راه های ارتباطی</h3>

            <div>
                <ul style="line-height: 33px;">
                    <li><strong>شرکت رایان اندیشه نصر:</strong> تهران، نارمک، بزرگراه شهید سلیمانی، بعد از چهارراه
                        سرسبز، پلاک ۶۴۰، واحد ۸، تلفن ۲-۷۷۲۷۳۱۶۰-۰۲۱</li>
                    <li><strong>دفتر بندرعباس: </strong>{{'09177563345' | faNum}} - {{'33381408-076' | faNum}} </li>
                    <li><strong>دفتر ساری: </strong>{{'09118644288' | faNum}} - {{'33391200-011' | faNum}}</li>
                    <li><strong>اتحادیه سراسری تعاونی های صیادی ایران:</strong> تهران- جمالزاده - خيابان جمالزاده شمالي-
                        خيابان باقرخان - پلاک ۲۱ - طبقه ۱</li>
                </ul>
            </div>
        </div>
    </div>
</section>

<footer id="site-footer">
    <div class="inner-content">
        <div class="flex-container">
            <a href="https://rayanandisheh.com/" class="" target="_blank">
                طراحی و توسعه شرکت دانش بنیان رایان اندیشه نصر - {{version | faNum}}
            </a>
        </div>
    </div>
</footer>